import { useCreateUserSettingsMutation, useReadUserSettingsQuery, useUpdateUserSettingsMutation } from 'services/user'
import { NotificationsSettingsForm } from '../NotificationsSettingsForm'
import { isFetchBaseQueryError } from 'shared/lib/isFetchBaseQueryError'
import { createBlankUserSettings } from 'domain/userSettings'
import { useEffect, useState } from 'react'
import { UserSettings } from 'shared/types/UserSettings'
import { CircularProgress } from '@mui/material'

interface NotificationsSettingsFormUpdateProps{
    onUpdateCompleted?: (event: any) => void 
    onFollowLink?: (event: any) => void 
}

export const NotificationsSettingsFormUpdate = (props: NotificationsSettingsFormUpdateProps): JSX.Element => {
    const {
        onUpdateCompleted,
        onFollowLink
    } = props

    const [userSettings, setUserSettings] = useState<UserSettings | undefined>(undefined)
    const [hasUserSettings, setHasUserSettings] = useState<boolean>(false)
    const [createUserSettings] = useCreateUserSettingsMutation()
    const [updateUserSettings] = useUpdateUserSettingsMutation()

    const handleNotificationsSettingsFormOnSubmit = async (value: any, event: any) => {
        const params = {
            settings: value
        }

        if (hasUserSettings === true) {
            await updateUserSettings(params)
            onUpdateCompleted?.(event)
            return
        }

        await createUserSettings(params)
        onUpdateCompleted?.(event)
    }

    const {
        data: readUserSettingsData,
        isLoading: readUserSettingsIsLoading,
        isFetching: readUserSettingsIsFetching,
        error: readUserSettingsError,
        refetch
    } = useReadUserSettingsQuery(undefined)

    useEffect(() => {
        if (readUserSettingsError !== undefined && isFetchBaseQueryError(readUserSettingsError)){
            if (readUserSettingsError.status === 404){
                const blankUserSettings = createBlankUserSettings()
                setUserSettings(blankUserSettings)
                  setHasUserSettings(false)
            }
        } else {
            setUserSettings(readUserSettingsData)
            setHasUserSettings(true)
        }
    }, [
        readUserSettingsData, readUserSettingsError
    ])

    if (userSettings === undefined){
        return (<>
                  <div><CircularProgress size={40} /></div>
        </>)
    }

    const handleNotificationsSettingsFormFollowLink = (event: any) => {
        onFollowLink?.(event)
    }

    return (
        <NotificationsSettingsForm
            onSubmit={handleNotificationsSettingsFormOnSubmit}
            onFollowLink={handleNotificationsSettingsFormFollowLink}
            value={userSettings}
            isLoading={false}
        />   
    )
}